import { updateActiveSummaryLink } from "./summary";

window.addEventListener('scroll', () => {
    updateActiveSummaryLink();
}, { passive: true });